// Shared auth/session helpers for logout + per-session checkout connect gating.

// localStorage keys @pooflabs/web persists the auth session under (confirmed in
// the SDK bundle: WebSessionManager.TAROBASE_SESSION_STORAGE_KEY +
// STORED_AUTH_METHOD_KEY). Clearing these defeats a "ghost" session whose
// persisted address no longer matches a live wallet.
const SESSION_LOCAL_KEYS = ['tarobase_session_storage', 'tarobase_last_auth_method'];
// sessionStorage keys the SDK MockAuthProvider uses to simulate a logged-in user.
const MOCK_AUTH_SESSION_KEYS = ['test-user-address', 'test-user-id', 'mock-auth-explicit-login'];

export const CHECKOUT_CONNECT_KEY_PREFIX = 'pp:checkout-connected:';

export function checkoutConnectKey(sessionId: string): string {
  return `${CHECKOUT_CONNECT_KEY_PREFIX}${sessionId}`;
}

/**
 * Full sign-out: run the platform logout, then defensively clear persisted
 * session storage so a mismatched/ghost session cannot reappear on reload, and
 * drop every per-session checkout connect marker so no stale wallet is treated
 * as "connected for paying".
 */
export async function clearPoofSession(logout?: () => Promise<void>): Promise<void> {
  try {
    await logout?.();
  } catch (err) {
    console.error('Poof logout failed; clearing local session anyway', err);
  }

  if (typeof window === 'undefined') return;

  try {
    for (const key of SESSION_LOCAL_KEYS) localStorage.removeItem(key);
    for (const key of MOCK_AUTH_SESSION_KEYS) sessionStorage.removeItem(key);
    for (const key of Object.keys(sessionStorage)) {
      if (key.startsWith(CHECKOUT_CONNECT_KEY_PREFIX)) sessionStorage.removeItem(key);
    }
  } catch (err) {
    console.error('Failed to clear local Poof session storage', err);
  }
}
